export const iconFontAwesomeSciencefictionExplosion = (
	<i className="fa-solid fa-explosion"></i>
);
